import { DateTime, Interval } from 'luxon';
import { BasicRange } from './range';

export type TimeLike = number | string | DateTime;

export type BasicInterval = BasicRange<TimeLike>;

export type Timezone = 'UTC' | 'LST';

export function parseUTCDateTime(input: TimeLike): DateTime {
    const options = { zone: 'utc' };

    return typeof input === 'string'
        ? DateTime.fromISO(input, options)
        : typeof input === 'number'
        ? DateTime.fromMillis(input, options)
        : DateTime.isDateTime(input)
        ? input.setZone('utc')
        : null;
}

export function parseUTCInterval(basic: BasicInterval | Interval): Interval {
    return Interval.fromDateTimes(
        parseUTCDateTime(basic.start),
        parseUTCDateTime(basic.end)
    );
}
